import styles from './index.module.scss';
import { utility } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';
import { Gap, gap } from '..';

type FlexDirection =
    'column'
    | 'row';

type Align =
    'initial'
    | 'center'
    | 'start'
    | 'end';

type Justify =
    'initial'
    | 'center'
    | 'space-evenly';

export const Flex = defineComponent({
    props: {
        direction: {
            required: false,
            type: String as PropType<FlexDirection>,
            default: 'column',
        },

        gap: {
            required: false,
            type: String as PropType<Gap>,
            default: 'normal',
        },

        as: {
            required: false,
            type: String,
            default: 'div',
        },

        wrap: {
            required: false,
            type: Boolean,
            default: false,
        },

        equally: {
            required: false,
            type: Boolean,
            default: false,
        },

        align: {
            required: false,
            type: String as PropType<Align>,
            default: 'initial',
        },

        justify: {
            required: false,
            type: String as PropType<Justify>,
            default: 'initial',
        },
    },

    computed: {
        align_items() {
            switch (this.align) {
                case 'start': return 'flex-start';
                case 'end': return 'flex-end';
                default: return this.align;
            }
        },
    },

    render() {
        return h(this.as, {
            class: {
                [utility.flex]: true,
                [styles.equally]: this.equally,
                [utility.justify_center]: this.justify === 'center',
                [utility.space_evenly]: this.justify === 'space-evenly',
            },
            style: {
                gap: gap(this.gap),
                'flex-direction': this.direction,
                'flex-wrap': this.wrap ? 'wrap' : 'nowrap',
                'align-items': this.align_items,
            },
        }, this.$slots.default ? this.$slots.default() : '');
    }
});
